var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5C21.9036 2.5 27.5 8.09644 27.5 15C27.5 21.9036 21.9036 27.5 15 27.5C12.9494 27.5 10.969 27.0049 9.19472 26.0728L3.83173 27.4692C3.26387 27.6171 2.68363 27.2766 2.53572 26.7088C2.48998 26.5332 2.48998 26.3488 2.53568 26.1733L3.93112 20.8128C2.9965 19.0367 2.5 17.0535 2.5 15C2.5 8.09644 8.09644 2.5 15 2.5ZM16.5646 16.25H10.9375L10.8103 16.2586C10.3527 16.3206 10 16.7129 10 17.1875C10 17.6621 10.3527 18.0544 10.8103 18.1164L10.9375 18.125H16.5646L16.6918 18.1164C17.1494 18.0544 17.5021 17.6621 17.5021 17.1875C17.5021 16.7129 17.1494 16.3206 16.6918 16.2586L16.5646 16.25ZM19.0625 11.875H10.9375L10.8103 11.8836C10.3527 11.9456 10 12.3379 10 12.8125C10 13.2871 10.3527 13.6794 10.8103 13.7414L10.9375 13.75H19.0625L19.1897 13.7414C19.6473 13.6794 20 13.2871 20 12.8125C20 12.3379 19.6473 11.9456 19.1897 11.8836L19.0625 11.875Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChat);
export default __webpack_public_path__ + "static/media/live-chat.6ce30c1a8e0203e565f5c63865bbfe58.svg";
export { ForwardRef as ReactComponent };